import { AfterViewInit, ChangeDetectorRef, Directive, ElementRef, HostBinding, inject, Input, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appCenterReveal]'
})
export class CenterReveal implements AfterViewInit, OnDestroy {

  @Input() revealDelay = 0;
  private observer?: IntersectionObserver;
  private hydrated = false;

  @HostBinding('class.is-visible-center') isVisible = false;
  @HostBinding('class.is-hidden-center') get isHidden() {
    return !this.isVisible;
  }

  private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly cdr = inject(ChangeDetectorRef);

  constructor() {
    if (typeof window !== 'undefined') {
      this.el.nativeElement.classList.add('is-hidden-center');
    }
  }

  ngAfterViewInit(): void {
    if (typeof window === 'undefined') return;

    const el = this.el.nativeElement;

    requestAnimationFrame(() => {
      this.hydrated = true;

      if (typeof IntersectionObserver === 'undefined') {
        this.showWithDelay();
        return;
      }

      this.observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.showWithDelay();
            this.observer?.disconnect();
            break;
          }
        }
      }, { threshold: 0.2 });

      this.observer.observe(el);

      const rect = el.getBoundingClientRect();
      const alreadyVisible = rect.top < window.innerHeight && rect.bottom >= 0;
      if (alreadyVisible) {
        this.showWithDelay();
      }
    });
  }

  private showWithDelay() {
    const delay = this.revealDelay || Math.random() * 150;
    setTimeout(() => {
      requestAnimationFrame(() => {
        this.isVisible = true;
        this.cdr.detectChanges();
      });
    }, delay + 150);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

}
